import React from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import Header from "./components/Header";

type Props = {};

const BranchPreview = (props: Props) => {
  return (
    <DashboardLayout title="Branch Management" back={true}>
      <Header title={"Branch Details"} />
      <p className="ml-[20px] mr-[14px] mt-[20px]">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, provident.
        Odio, ad! Eum, illum deleniti voluptas, magnam doloribus repudiandae
        accusamus quae qui delectus necessitatibus maxime cupiditate. Eum vel
        officia ex?
      </p>
    </DashboardLayout>
  );
};

export default BranchPreview;
